export default __webpack_public_path__ + "static/media/blogImg.e8a74119.png";